export default "__VITE_ASSET__DyOM_cKb__"